import { useTranslation } from 'react-i18next';
import React, { useCallback, useMemo } from 'react';
import cx from 'clsx';
import HelperTooltip from '../HelperTooltip';
import { useTheme } from '@/hooks';
import {
  IconOrgVerified,
  IconOfficialUnverified,
  IconOfficialUnverifiedDark,
} from '@/assets/official';
import style from './index.module.css';

export const OrgVerifiedLogo = ({
  size = 22,
  className,
  disableTooltip,
  marginLeft = 12,
  style: customStyle,
  marginRight = 0,
  unverified = false,
  getTooltipContainer,
}: {
  size?: number;
  disableTooltip?: boolean;
  className?: string;
  verifiedLink?: string;
  style?: React.CSSProperties;
  marginLeft?: number;
  marginRight?: number;
  unverified?: boolean;
  getTooltipContainer?: (dom: HTMLElement) => HTMLElement;
}) => {
  const { t } = useTranslation();

  const { isDark } = useTheme();
  const Logo = useMemo(
    () =>
      unverified ? (isDark ? IconOfficialUnverifiedDark : IconOfficialUnverified) : IconOrgVerified,
    [isDark, unverified],
  );
  const logo = useMemo(
    () => (
      <Logo
        className={cx(style.logo, className)}
        width={size}
        height={size}
        style={{ marginLeft, marginRight, ...customStyle }}
      />
    ),
    [Logo, className, customStyle, marginLeft, marginRight, size],
  );

  const handleOfficialLinkClick = useCallback(() => {
    window.open('https://cloud.debank.com/');
  }, []);

  const title = useMemo(
    () => (
      <div className={style.tooltipTitle}>
        <div>{unverified ? t('OrgVerifiedLogo.1am5xfa') : t('OrgVerifiedLogo.7lh8gm')}</div>
        <div className={style.link} onClick={handleOfficialLinkClick}>
          {t('OrgVerifiedLogo.twa8lk')}
        </div>
      </div>
    ),
    [handleOfficialLinkClick, unverified, t],
  );

  return disableTooltip ? (
    logo
  ) : (
    <HelperTooltip
      placement="bottom"
      overlayStyle={{ maxWidth: 600 }}
      title={title}
      getTooltipContainer={getTooltipContainer}>
      {logo}
    </HelperTooltip>
  );
};
